import { useSelector } from "react-redux";
import { useState } from "react";

const DashboardView = ({ category }) => {
  const { registeredUsers, loading, error } = useSelector(
    (state) => state.users,
  );
  const labTests = useSelector((state) => state.labTests.tests || []);
  const [searchTerm, setSearchTerm] = useState("");

  const today = new Date().toISOString().split("T")[0];

  const uniquePatients = Object.values(
    labTests.reduce((acc, test) => {
      const email = test?.patientInfo?.email;
      if (email && !acc[email]) {
        acc[email] = { ...test.patientInfo };
      }
      return acc;
    }, {}),
  );

  const totalPatients = uniquePatients.length;
  const activeTests = labTests.filter((t) => t.status === "Active").length;
  const pendingTests = labTests.filter((t) => t.status === "Pending").length;
  const todaysAppointments = labTests.filter(
    (t) => t?.date?.split("T")[0] === today,
  ).length;

  const filteredPatients = Object.values(
    labTests.reduce((acc, test) => {
      const patient = test.patientInfo;
      const email = patient?.email;
      if (email && !acc[email]) {
        acc[email] = {
          ...patient,
          status: test.status,
          testDate: test.date,
        };
      }
      return acc;
    }, {}),
  )
    .filter((patient) => {
      const term = searchTerm.toLowerCase();
      return (
        patient?.name?.toLowerCase().includes(term) ||
        patient?.email?.toLowerCase().includes(term) ||
        patient?.phone?.toLowerCase().includes(term)
      );
    })
    .sort((a, b) => a.name?.localeCompare(b.name));

  if (loading) return <p className="p-4 text-gray-500">Loading...</p>;
  if (error) return <p className="p-4 text-red-500">Error: {error}</p>;

  return (
    <>
      {/* Home Dashboard */}
      {category === "Home" && (
        <section className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm">
          <h2 className="text-2xl font-semibold mb-6 text-green-700">
            🏠 Home Dashboard
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-4 bg-green-50 border border-green-200 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-green-800 mb-2">
                📊 Total Patients
              </h3>
              <p className="text-xl font-bold">{totalPatients}</p>
            </div>

            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">
                🧪 Active Lab Tests
              </h3>
              <p className="text-xl font-bold">{activeTests}</p>
            </div>

            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-yellow-800 mb-2">
                ⚠️ Pending Results
              </h3>
              <p className="text-xl font-bold">{pendingTests}</p>
            </div>

            <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg shadow-sm">
              <h3 className="text-lg font-semibold text-purple-800 mb-2">
                📅 Today's Appointments
              </h3>
              <p className="text-xl font-bold">{todaysAppointments}</p>
            </div>
          </div>
        </section>
      )}

      {/* All Patients Section */}
      {category === "Patients" && (
        <section className="border border-gray-200 rounded-lg p-6 bg-white shadow-sm mt-6">
          <h2 className="text-2xl font-semibold mb-6 text-blue-700">
            👥 All Patients
          </h2>

          <input
            type="text"
            placeholder="Search patients..."
            className="mb-6 w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          {filteredPatients.map((patient, idx) => (
            <div
              key={patient.email || idx}
              className="mb-6 p-5 border border-gray-200 rounded-xl shadow bg-gray-50 hover:bg-gray-100 transition"
            >
              <h4 className="text-lg font-semibold text-gray-800 mb-3">
                👤 Patient Details
              </h4>
              <p>
                <strong>Name:</strong> {patient.name || "—"}
              </p>
              <p>
                <strong>Email:</strong> {patient.email || "—"}
              </p>
              <p>
                <strong>Phone:</strong> {patient.phone || "—"}
              </p>
              <p>
                <strong>Status:</strong> {patient.status || "—"}
              </p>
              <p>
                <strong>Test Date:</strong>{" "}
                {patient.testDate
                  ? new Date(patient.testDate).toLocaleDateString()
                  : "—"}
              </p>
            </div>
          ))}
        </section>
      )}
    </>
  );
};

export default DashboardView;
